import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";
import { device } from "../device.js";

import Lottie from "react-lottie-player";

import ArrowDown from "../../assets/icon/arrow_down.svg";
import ArrowUp from "../../assets/icon/arrow_up.svg";
import DESKTOP_PHONE from "../../assets/desktop_phone.png";
import QR_IMAGE_ANDROID from "../../assets/error_browser/hojeng-android-qr-code.svg";
import QR_IMAGE_IOS from "../../assets/error_browser/hojeng-ios-qr-code.svg";

import LABEL_IMAGE_ANDROID from "../../assets/error_browser/googlePlay.svg";
import LABEL_IMAGE_IOS from "../../assets/error_browser/DownloadOnTheAppStore.svg";

const Wrapper = styled.div`
    width: 100vw;
    height: 100vh;
    background-color: #d4d4d4;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
`;

const LottieWrapper = styled.div`
    position: relative;
    width: 225px;
    min-width: 225px;
    height: auto;
    margin-right: 5%;
    margin-left: 1vw;
    @media ${device.laptop} {
        width: 280px;
        min-width: 280px;
    }
    @media ${device.laptopL} {
        width: 360px;
        min-width: 360px;
    }
    @media ${device.desktop} {
        width: 280px;
        min-width: 280px;
    }
    @media ${device.desktopL} {
        width: 360px;
        min-width: 360px;
    }
`;

const LottieContent = styled.div`
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const QrText = styled.p`
    text-align: center;
    margin-top: 0;
    font-size: 0.8rem;

    @media ${device.laptop} {
        font-size: 1rem;
    }
    @media ${device.laptopL} {
        font-size: 1.2rem;
    }
    @media ${device.desktop} {
        font-size: 1rem;
    }
    @media ${device.desktopL} {
        font-size: 1.2rem;
    }
`;
const QrWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    width: 100%;
`;
const QrContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
const QrImage = styled.img`
    height: auto;
    object-fit: contain;
    object-position: center;
    margin-bottom: 12%;
    width: 60px;
    @media ${device.laptop} {
        width: 75px;
    }
    @media ${device.laptopL} {
        width: 100px;
    }
    @media ${device.desktop} {
        width: 75px;
    }
    @media ${device.desktopL} {
        width: 100px;
    }
`;
const LabelImage = styled.img`
    height: auto;
    width: calc(${(props) => `${props.configSize}`} * 60px);
    margin-bottom: 24px;
    @media ${device.laptop} {
        width: calc(${(props) => `${props.configSize}`} * 75px);
        margin-bottom: 0;
    }
    @media ${device.laptopL} {
        width: calc(${(props) => `${props.configSize}`} * 100px);
        margin-bottom: 0;
    }
    @media ${device.desktop} {
        width: calc(${(props) => `${props.configSize}`} * 75px);
        margin-bottom: 0;
    }
    @media ${device.desktopL} {
        width: calc(${(props) => `${props.configSize}`} * 100px);
        margin-bottom: 0;
    }
`;

const StyledLottie = styled(Lottie)`
    width: 100%;
    height: 100%;
`;

const PhoneWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-left: 4%;
    margin-right: 4%;
    width: 20%;
    min-width: 180px;

    @media ${device.laptop} {
        width: 15%;
        min-width: 200px;
    }
    @media ${device.laptopL} {
        width: 15%;
        max-width: 275px;
    }
    @media ${device.desktop} {
        width: 15%;
        min-width: 200px;
    }
    @media ${device.desktopL} {
        width: 15%;
    }
`;

const PhoneTextStyle = styled.p`
    font-size: 0.7rem;
    @media ${device.laptop} {
        min-width: 210px;
        font-size: 0.9rem;
    }
    @media ${device.laptopL} {
        width: 270px;
        font-size: 1.1rem;
    }
    @media ${device.desktop} {
        min-width: 210px;
        font-size: 0.9rem;
    }
    @media ${device.desktopL} {
        width: 270px;
        font-size: 1.1rem;
    }
`;

const PhoneImage = styled.img`
    object-size: contain;
    width: 100%;
`;

const TextWrapper = styled.div`
    min-width: 450px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    font-family: "Nunito", sans-serif;
    font-size: 0.8rem;
    font-weight: 400;
    @media ${device.laptop} {
        min-width: 550px;
        font-size: 1rem;
    }
    @media ${device.laptopL} {
        min-width: 660px;
        font-size: 1.2rem;
    }
    @media ${device.desktop} {
        min-width: 550px;
        font-size: 1rem;
    }
    @media ${device.desktopL} {
        min-width: 660px;
        font-size: 1.2rem;
    }
`;
const ContentWrapper = styled.div`
    height: 80vh;
    width: 470px;
    overflow: hidden;
    scroll-behavior: smooth;
    min-width: 470px;
    @media ${device.laptop} {
        min-width: 570px;
        font-size: 1rem;
    }
    @media ${device.laptopL} {
        min-width: 680px;
        font-size: 1.2rem;
    }
    @media ${device.desktop} {
        min-width: 570px;
        font-size: 1rem;
    }
    @media ${device.desktopL} {
        min-width: 680px;
        font-size: 1.2rem;
    }
`;
const EnTextWrapper = styled.div``;
const ZhTextWrapper = styled.div``;
const LinkText = styled.a`
    color: #ff415e;
`;
const ArrowStyle = styled.img`
    object-fit: contain;
    width: 30px;
    height: auto;
    margin: 0 auto;
    cursor: pointer;
    @media ${device.laptop} {
        width: 40px;
    }
    @media ${device.laptopL} {
        width: 50px;
    }
    @media ${device.desktop} {
        width: 40px;
    }
    @media ${device.desktopL} {
        width: 50px;
    }
`;

const BrowserErrorPage = () => {
    const { i18n } = useTranslation();

    const [lottie, setLottie] = useState("");

    useEffect(() => {
        const lottieLoader = async () => {
            // if (i18n.language === "zh") {
            //     const lottieData = await import(
            //         "../../assets/error_lottie/error_browser/zh/lennie_kiss_phone.json"
            //     );
            //     setLottie(lottieData.default);
            // } else {
            //     const lottieData = await import(
            //         "../../assets/error_lottie/error_browser/en/lennie_kiss_phone.json"
            //     );
            //     setLottie(lottieData.default);
            // }
            const lottieData = await import(
                "../../assets/error_lottie/error_browser/Hojeng_Lennie_bubble.json"
            );
            setLottie(lottieData.default);
        };
        lottieLoader();
    }, [i18n.language]);

    const contentWrapperRef = useRef(null);
    const sectionOne = useRef(null);
    const sectionTwo = useRef(null);

    const handleScrollToBottom = () => {
        console.log("scroll to bottom");
        sectionTwo.current.scrollIntoView();
    };
    const handleScrollToTop = () => {
        console.log("scroll to top");
        sectionOne.current.scrollIntoView();
    };

    return (
        <Wrapper>
            <PhoneWrapper>
                <PhoneImage src={DESKTOP_PHONE} />
                <PhoneTextStyle>
                    Find your joy and share it! <br />
                    <strong>#HoJengAR #BuiltWithGoogle</strong>
                </PhoneTextStyle>
            </PhoneWrapper>
            <ContentWrapper ref={contentWrapperRef}>
                <TextWrapper ref={sectionOne}>
                    <EnTextWrapper>
                        <h2>What is HO JENG AR?</h2>
                        <p>
                            HO JENG AR is a mobile application featuring an
                            immersive
                            <br />
                            experience with six iconic AR characters designed
                            for Hong Kong - <br />
                            “HO JENG AR” in Cantonese also means “Awesome!”.
                            Once you
                            <br /> open the app, virtual host Lenni will tell
                            the HO JENG AR story and <br />
                            provide step-by-step instructions that guide you to
                            unlock the <br />
                            characters by scanning an object to bring each AR
                            character to life!
                        </p>
                        <p>
                            Learn more at{" "}
                            <LinkText
                                href="https://forhongkong.withgoogle.com/intl/en/sharejoyhk/"
                                target="_"
                            >
                                Google for Hong Kong
                            </LinkText>
                            .
                        </p>
                    </EnTextWrapper>
                    <ZhTextWrapper>
                        <h2>「HO JENG AR」是什麼?</h2>
                        <p>
                            「HO JENG AR」
                            是專為香港而設的手機應用程式，這名稱正正是廣東話中
                            <br />
                            的「好正啊！」。透過六個獨具香港特色的 AR
                            角色，Google 期望以生動有
                            <br />
                            趣的方式為香港人送上驚嘆及樂趣。手機應用程式中的數碼導遊「
                            Lenni 斯<br />
                            斯」會與大家分享講解如何利用手機鏡頭解鎖角色，以及如何與
                            AR 角色們拍
                            <br />
                            照或影片，與家人好友分享快樂！
                        </p>
                        <p>
                            詳情請參閱{" "}
                            <LinkText
                                href="https://forhongkong.withgoogle.com/intl/zh-HK/sharejoyhk/"
                                target="_"
                            >
                                Google for Hong Kong網頁
                            </LinkText>
                            .
                        </p>
                    </ZhTextWrapper>
                    <ArrowStyle
                        src={ArrowDown}
                        onClick={handleScrollToBottom}
                    />
                </TextWrapper>
                <TextWrapper ref={sectionTwo}>
                    <ArrowStyle src={ArrowUp} onClick={handleScrollToTop} />
                    <EnTextWrapper>
                        <h2>How it works:</h2>
                        <p>
                            • Unlock characters by scanning the right objects
                            with your camera <br />
                            (follow the clues in the app)
                            <br />
                            • Once you unlock a character, you can play with
                            them, take a pic or <br />
                            video and share across your social networks
                            <br />
                            • Collect Joy Points by unlocking, tapping and
                            sharing your <br />
                            characters
                            <br />• Use Joy Points to get in-app and real world
                            rewards
                        </p>
                    </EnTextWrapper>
                    <ZhTextWrapper>
                        <h2>玩法 ：</h2>
                        <p>
                            • 按程式內提示，用鏡頭掃瞄物件以解鎖角色
                            <br />
                            •
                            解鎖角色後與角色互動，拍照或拍攝影片，並在社交平台分享
                            <br />
                            • 解鎖角色，與角色互動和分享以收集 Joy Points
                            <br />• 使用 Joy Points 兌換獎賞
                        </p>
                    </ZhTextWrapper>
                </TextWrapper>
            </ContentWrapper>
            <LottieWrapper>
                <LottieContent>
                    <QrText>
                        Okay, stop reading. <br />
                        Start playing! <br />
                        <br />
                        凖備開始尋找快樂旅程！
                    </QrText>
                    <QrWrapper>
                        <QrContainer>
                            <QrImage src={QR_IMAGE_ANDROID} />
                            <LabelImage
                                configSize={1.05}
                                src={LABEL_IMAGE_ANDROID}
                            />
                        </QrContainer>
                        <QrContainer>
                            <QrImage src={QR_IMAGE_IOS} />
                            <LabelImage configSize={1} src={LABEL_IMAGE_IOS} />
                        </QrContainer>
                    </QrWrapper>
                </LottieContent>
                <StyledLottie
                    loop
                    play
                    animationData={lottie}
                    rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
                />
            </LottieWrapper>
        </Wrapper>
    );
};

export default BrowserErrorPage;
